import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { NgClass } from '@angular/common';
import { Router } from '@angular/router';

/**
 * 預約頁面底版，顯示預約步驟進度
 */
@Component({
  selector: 'app-reserve',
  standalone: true,
  imports: [RouterOutlet, TranslatePipe, NgClass],
  templateUrl: './reserve.component.html',
  styleUrl: './reserve.component.scss',
})
export class ReserveComponent {
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  router = inject(Router);
  healthPlan = this.sharedStorageService.get('healthPlan');
  
  get isCompletePage(): boolean {
    return this.router.url.includes('/complete');
  }

  // 是否為特殊活動頁面
  get isSpecialHealthPlan(): boolean {
    return this.sharedStorageService.get('healthPlan') === 'special';
  }

  get isLoadingPage(): boolean {
    return this.router.url.includes('/reserve/loading');
  }

  // 當前預約步驟
  get reserveStep(): number {
    return this.sharedStorageService.get('reserveStep') ?? 1;
  }
}
